import {type HttpHeaders, HttpParams} from '@angular/common/http'
import {Injectable, inject} from '@angular/core'
import {type Observable, map} from 'rxjs'
import type {Endpoints} from '@models/endpoints'
import type {UVEuser} from '@models/uve-user'
import {UVEApiService} from '@service/uve/api.service'
import type {IApiService} from '@uve-solutions/f-chat/core'

@Injectable({providedIn: 'root'})
export class ChatApiAdapter implements IApiService {
  private readonly uveApiService = inject(UVEApiService)

  private readonly cleanUrl = (url: string): Endpoints => {
    return (url.startsWith('/') ? url.substring(1) : url) as Endpoints
  }

  get = <T>(url: string, httpParams?: unknown): Observable<T> => {
    const params = this.getRequestHttpParams(httpParams)
    return this.uveApiService.get(this.cleanUrl(url), params).pipe(map(res => res as T))
  }

  post = <T>(url: string, data: unknown, httpParams?: unknown): Observable<T> => {
    const params = this.toHttpParams(httpParams)
    return this.uveApiService.postWithOptions(this.cleanUrl(url), data, params).pipe(map(res => res as T))
  }

  put = <T>(url: string, data?: unknown): Observable<T> => {
    return this.uveApiService.put(this.cleanUrl(url), data).pipe(map(res => res as T))
  }

  getUser = (): UVEuser => {
    return this.uveApiService.getSessionUser()
  }

  sessionToken = (): string | null => this.uveApiService.getSessionUser()?.token ?? null

  private readonly toHttpParams = (httpParams?: any, headers: HttpHeaders = null, body = null) => {
    const params = this.getRequestHttpParams(httpParams)

    return {
      params,
      headers,
      body,
    }
  }

  private readonly getRequestHttpParams = (httpParams?: any) => {
    let params = new HttpParams()
    for (const key in httpParams) {
      if (Object.hasOwn(httpParams, key) && httpParams[key] != null) {
        params = params.append(key, httpParams[key])
      }
    }

    return params
  }
}
